import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey, getMembersKey } from '../../utils/keys';
import { getAuthMemberKey } from '../../utils/keys/authToken.keys';
export const useCancelEmailUpdate = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.members.cancelEmailUpdate(input), {
        onSettled: () => {
            queryClient.invalidateQueries(getMembersKey());
            queryClient.invalidateQueries(getAuthTokensKey());
            queryClient.invalidateQueries(getAuthMemberKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCancelEmailUpdate.js.map